import React from "react";
import HeroSection from "./components/HeroSection";

const About = () => {
  return <HeroSection name="Umer Ecommerce"/>;
};

export default About;